import React, { useState } from "react";
import "./TranscriptionPanel.css";

const TranscriptionPanel = ({ lines, hoveredLine, setHoveredLine }) => {
  const [showHarakat, setShowHarakat] = useState(true);
  const [showTashkil, setShowTashkil] = useState(true);

  // Regex patterns for harakat (vowel marks) and tashkil (other diacritics)
  const harakatRegex = /[\u064E\u064F\u0650\u064B\u064C\u064D\u0652\u0653\u0670]/g;  
  const tashkilRegex = /[\u0651\u0654\u0655\u0656\u0657\u0658\u0659\u065A\u065B\u065C\u065D\u065E\u065F]/g;

  const processText = (text) => {
    if (!text) return "";
    
    let processed = text;
    
    if (!showHarakat) {
      processed = processed.replace(harakatRegex, "");
    }
    
    if (!showTashkil) {
      processed = processed.replace(tashkilRegex, "");
    }
    
    return processed;
  };

  return (
    <div className="transcription-panel">
      <div className="transcription-controls">
        <button 
          className={`toggle-button ${showHarakat ? "active" : ""}`} 
          onClick={() => setShowHarakat(!showHarakat)}
        >
          {showHarakat ? "Hide Harakat" : "Show Harakat"}
        </button>
        <button 
          className={`toggle-button ${showTashkil ? "active" : ""}`} 
          onClick={() => setShowTashkil(!showTashkil)}
        >
          {showTashkil ? "Hide Tashkil" : "Show Tashkil"}
        </button>
      </div>
      <div className="transcription-content">
        {lines.map((line, index) => (
          <div
            key={index}
            className={`line-item ${hoveredLine === line ? "active" : ""}`}
            onMouseEnter={() => setHoveredLine(line)}
            onMouseLeave={() => setHoveredLine(null)}
          >
            <div className="line-number">{line.line}</div>
            <div className="transcription" dir="rtl">
              {processText(line.transcription)}
            </div>
            {line.translation && <div className="translation">{line.translation}</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TranscriptionPanel;